import url from "url/index";
import { devtools } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

interface IRouterHistoryStore {
  previous: string;
  setPreviousPage: (previous: string) => void;
}

export const useRouterHistoryStore =
  createWithEqualityFn<IRouterHistoryStore>()(
    devtools((set) => ({
      previous: url.config.casino.root,
      setPreviousPage: (previous) => {
        set({ previous });
      },
    })),
    shallow,
  );
